/* eslint-disable react/no-unknown-property */
import classnames from "classnames";
import React, { useContext, useEffect, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useLocation, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import {
  Button,
  Row,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Modal, Form } from "react-bootstrap";
import moment from "moment";
import DatePicker, { Calendar } from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/red.css";

const AddUser = ({
  show,
  handleClose,
  formik,
  t,
  submitting,
  isEdit,
}) => {
  
  return (
    <Modal
      size="md"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      // backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? t("Edit User") : t("Add New User")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <div className="col-12">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>{t("Email")}</Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  placeholder=""
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red" }}>
                    {formik.errors.email}
                  </div>
                ) : null}
              </Form.Group>
            </div>
          
           
          </Row>

          <div className="text-end">
            <Button
              disabled={submitting}
              type="submit"
              variant="primary"
              className="all-common-btn mx-1"
              style={{ marginLeft: 10 }}
            >
              {isEdit ? t("Update") : t("Submit")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

AddUser.propTypes = {
  t: PropTypes.any,
};

export default withRouter(withTranslation()(AddUser));
